import {
	AlertDescription,
	AlertTitle,
	Alert,
} from '@dealstack/frontend/shared/components/Alert/Alert';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Box, Button } from '@mantine/core';

interface Props {
	onRegenerate: () => void;
}

export const InvalidPhoneNumberAlert = ({ onRegenerate }: Props) => {
	const tInvestor = useTranslationInvestor();
	return (
		<>
			<Box style={{ marginTop: '0.5rem' }}>
				<Alert state="dangerV3" size="m">
					<AlertTitle>{tInvestor('documents.invalid_phone_number.title')}</AlertTitle>
					<AlertDescription>
						{tInvestor('documents.invalid_phone_number.description')}
					</AlertDescription>
				</Alert>
			</Box>
			<Box style={{ marginTop: '1rem' }}>
				<Button
					onClick={onRegenerate}
					variant="secondary"
					size="sm"
					rightSection={<Icon variant="refresh-v3" size="lg" />}
				>
					{tInvestor('documents.invalid_phone_number.regenerate_documents')}
				</Button>
			</Box>
		</>
	);
};
